export const PaymentType = {
    WeeklyDirectDebit: 'weekly_direct_debit',
    WeeklyTransfer: 'weekly_transfer',
    BiWeeklyDirectDebit: 'bi_weekly_direct_debit',
    BiWeeklyTransfer: 'bi_weekly_transfer',
    MonthlyDirectDebit: 'monthly_direct_debit',
    MonthlyTransfer: 'monthly_transfer',
}

export function getNameForPaymentType(type) {
    switch (type) {
        case PaymentType.WeeklyDirectDebit:
            return 'Wöchentlich Lastschrift';
        case PaymentType.WeeklyTransfer:
            return 'Wöchentlich Überweisung';
        case PaymentType.BiWeeklyDirectDebit:
            return '14 tägige Lastschrift';
        case PaymentType.BiWeeklyTransfer:
            return '14 tägige Überweisung';
        case PaymentType.MonthlyDirectDebit:
            return 'Monatlich Lastschrift';
        case PaymentType.MonthlyTransfer:
            return 'Monatlich Überweisung';
        default:
            return '';
    }
}

export function allowedPaymentMethods(destination) {
    switch (destination) {
        case Destination.Work:
            return [
                PaymentType.WeeklyDirectDebit,
                PaymentType.WeeklyTransfer,
                PaymentType.MonthlyDirectDebit,
            ];
        case Destination.School:
            return [
                PaymentType.MonthlyDirectDebit,
            ]
        case Destination.Kita:
            return [
                PaymentType.MonthlyDirectDebit,
            ];
        case Destination.Home:
            return [
                PaymentType.BiWeeklyDirectDebit,
                PaymentType.BiWeeklyTransfer,
                PaymentType.MonthlyDirectDebit,
            ];
        default:
            throw new Error(`Could not determine allowed payment methods. Unknown destination ${destination}`);

    }
}

export function paymentMethodRequiresBankAccountInfo(paymentMethod) {
    return paymentMethod === PaymentType.MonthlyDirectDebit
        || paymentMethod === PaymentType.WeeklyDirectDebit
        || paymentMethod === PaymentType.BiWeeklyDirectDebit;
}

export const RegistrationRole = {
    Child: 'child',
    Adult: 'adult',
}

export const Destination = {
    Work: 'work',
    School:'school',
    Kita: 'kita',
    Home: 'home',
}

export const Attention = {
    HomepageSearchEngine: 'homepage_search_engine',
    SocialMedia: 'social_media',
    FriendsColleagues: 'friends_colleagues',
    VehicleSeen: 'vehicle_seen',
    OutsideService: 'outside_service',
    Flyer: 'flyer',
    SchoolKita: 'school_kita',
    Other: 'other',
}

export function getAttentionName(attentionType) {
    switch (attentionType) {
        case Attention.HomepageSearchEngine:
            return 'Homepage / Google und ähnliche Suchmaschinen';
        case Attention.SocialMedia:
            return 'Social Media';
        case Attention.FriendsColleagues:
            return 'Freunden & Kollegen';
        case Attention.VehicleSeen:
            return 'Fahrzeug gesehen';
        case Attention.OutsideService:
            return 'Außendienst';
        case Attention.Flyer:
            return 'Flyer';
        case Attention.SchoolKita:
            return 'Schule/Kita ist in der Versorgung';
        case Attention.Other:
            return 'Sonstiges';
        default:
            return '';
    }
}
